<template>
  <div class="app-main-content warehouse-home">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          :config-module="configModule"
          :reset="true"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          @click-more="value=>filter.isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button
              type="primary"
              @click="arriveStorageClickHandler"
            >{{ $t('Warehouse.WarehouseIn') }}</el-button>
            <el-button
              type="primary"
              @click="deliverClickHandler"
            >{{ $t('Warehouse.WarehouseOut') }}</el-button>
            <el-button
              v-if="privilege.charge.chargeView"
              :disabled="!selectRow"
              type="primary"
              @click="chargeClickHandler"
            >{{ $t('SeaExport.Charge') }}</el-button>
            <el-button
              type="primary"
              @click="warehouseClickHandler"
            >{{ $t('Warehouse.NewWarehouseFee') }}</el-button>
            <el-button
              type="primary"
              @click="onPrint"
            >{{ $t('SeaExport.print') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :config-module="configModule"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :wrap-text="true"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :config-module="configModule"
            :total="total"
            :page.sync="filterJson.pageNum"
            :limit.sync="filterJson.pageSize"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :printed-callback="templateSelectorDialog.printedCallback"
      :v2-check-callback="templateSelectorDialog.printedCallback"
    />
    <!-- 附件 -->
    <upload-common-file
      :visible.sync="uploadCommonFileDialog.visible"
      :model="uploadCommonFileDialog.model"
      :document-category="documentCategory"
    />
    <!-- 出库入库 -->
    <in-or-out-warehouse-form
      :type="inOrOutWarehouseDialog.type"
      :title="inOrOutWarehouseDialog.title"
      :visible="inOrOutWarehouseDialog.visible"
      :job="inOrOutWarehouseDialog.job"
      @close="inOrOutWarehouseDialog.visible = false"
      @ok="onSaveInOrOutState"
    />
    <add-warehouse-charge-dialog
      :visible="addWarehouseChargeDialog.visible"
      :job-list="addWarehouseChargeDialog.jobList"
      @close="addWarehouseChargeDialog.visible = false"
    />
    <warehouse-charge-dialog
      :visible="chargeDialog.visible"
      :job="chargeDialog.job"
      :lob="lob"
      @close="chargeDialog.visible = false"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { queryWareHouse, saveInOrOutWareHouse } from '@/api/SeaImport/seaImportJob'
import StrUtils from '@/utils/StrUtils'
import LandTransportationForm from '@/views/cargo/v0/SeaExport/LandTransportation/components/LandTransportationForm'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { DocumentManage, ensureExecuteSuccess } from '@/utils/commonUtil'
import UploadCommonFile from '@/components/Cargo/Job/uploadCommonFile'
import * as DocumentSource from '@/class/cargo/model/parameters/DocumentSource'
import InOrOutWarehouseForm from '@/components/Cargo/Warehouse/components/warehouseHome/inOrOutWarehouseForm'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AddWarehouseChargeDialog from '@/components/Cargo/Warehouse/components/warehouseHome/addWarehouseChargeDialog'
import WarehouseChargeDialog from '@/components/Cargo/Warehouse/components/warehouseHome/warehouseChargeDialog'
import hblIcon from '@/assets/h_resize.png'
import mblIcon from '@/assets/m_resize.png'
import * as LayersUtil from '@/class/cargo/model/utils/LayersUtil'
import checkPermission from '@/utils/permission'
import { queryAiWareHouse } from '@/api/AirImport/aiBooking'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'WarehouseHome',
  components: { WarehouseChargeDialog, AddWarehouseChargeDialog, InOrOutWarehouseForm, UploadCommonFile, CargoTemplateSelectDialog, LandTransportationForm, searchItem },
  props: {
    configModule: { type: String, required: true },
    lob: { type: String, required: true }
  },
  data() {
    return {
      fullscreenLoading: false,
      documentCategory: DocumentSource.WAREHOUSE.code.toString(),
      total: 0,
      data: {},
      selectRow: null,
      documentManage: new DocumentManage(),
      inOrOutWarehouseDialog: {
        visible: false,
        title: '',
        type: '',
        job: {}
      },
      privilege: {
        charge: {
          chargeView: this.$checkPermission(['tab_Charge_chargeView'])
        }
      },
      chargeDialog: {
        visible: false,
        job: {}
      },
      job: {},
      uploadCommonFileDialog: {
        visible: false,
        model: {}
      },
      addWarehouseChargeDialog: {
        visible: false,
        jobList: []
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'WAREHOUSE_IMPORT',
        data: {},
        printedCallback: null
      },
      filterJson: {
        pageNum: 1,
        pageSize: 10
      },
      filter: {
        isAdvancedQuery: false,
        jobNo: '',
        pageNum: 1,
        pageSize: 40,
        branchId: 0, // 分公司ID
        conditions: [] // 查询条件
      },
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        onRowClicked: this.onRowClickedEvent,
        autoGroupColumnDef: {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 240,
          headerCheckboxSelection: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              const currentJob = params.data
              if (currentJob && currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                return false
              }
              return true
            },
            innerRenderer: params => {
              const currentJob = params.data
              if (currentJob && currentJob.hasOwnProperty('dataType') && Number(currentJob.dataType) !== 1 && Number(currentJob.dataType) !== 2) {
                const icon = Number(currentJob.dataType) === 5 ? hblIcon : mblIcon
                return `<span><img src="${icon}" height="16" width="16" style="vertical-align: sub;margin-right:3px;" />${params.value}</span>`
              }
              const pushMethodPath = this.documentManage.getPath('routerPush')
              return `<a href="javascript:void(0)" onclick="${pushMethodPath}('${params.value}')" style="color:#0052cc;">${params.value}</a>`
            }
          }
        },
        // 选中 勾选框或者其他列 都会触发
        onCellFocused: (event) => {
          this.onGridCellFocused(event)
        },
        getRowStyle: (params) => {
          const row = params.data
          if (!row) {
            return {}
          }
          const colorType = Number(this.$store.state.settings.colorType) === 1
          if (colorType && this.lob !== 'AI') {
            return JobUtils.financeColor(row)
          } else if (row.hasOwnProperty('dataType') && (Number(row.dataType) === 1 || Number(row.dataType) === 2)) {
            if (Object.prototype.hasOwnProperty.call(row, 'blocked') && row.blocked) {
              return { 'background': LayersUtil.STATE_BLOCKED.colorValue }
            } else {
              const jobState = String(row.jobState) || ''
              for (const stateColor of LayersUtil.COLOR_STATES) {
                if (jobState === stateColor.colorKey) {
                  return { 'background': stateColor.colorValue }
                }
              }
            }
          }
          return {}
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('SeaExport.ConsignationCompany'), field: 'customerId', colId: 'customerId', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.Mbl2'), field: 'mbl', colId: 'mbl', width: 100
        },
        {
          headerName: this.$t('SeaExport.Hbl2'), field: 'hbl', colId: 'hbl', width: 100
        },
        {
          headerName: this.$t('SeaExport.CustomsHblNo'), field: 'customsHbl', colId: 'customsHbl', width: 100
        },
        {
          headerName: this.$t('SeaExport.Vessel'), field: 'vessel', colId: 'vessel', width: 100
        },
        {
          headerName: this.$t('SeaExport.Voyage'), field: 'voyageFlight', colId: 'voyageFlight', width: 100
        },
        {
          headerName: this.$t('SeaExport.PortOfLoadingAI'), field: 'loadingPortCode', colId: 'loadingPortCode', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'code')
          }
        },
        {
          headerName: this.$t('SeaExport.Quantity'), field: 'quantityContract', colId: 'quantityContract', width: 100
        },
        {
          headerName: this.$t('SeaExport.GrossWeight'), field: 'weightContract', colId: 'weightContract', width: 100
        },
        {
          headerName: this.$t('SeaExport.Cubage'), field: 'cubageContract', colId: 'cubageContract', width: 100
        },
        {
          headerName: this.$t('SeaExport.DateOfArrival'), field: 'eta', colId: 'eta', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.StorageDay'), field: 'arriveStorageDate', colId: 'arriveStorageDate', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('Warehouse.DeliveryDay'), field: 'deliverDate', colId: 'deliverDate', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.Marks'), field: 'mark', colId: 'mark', width: 100
        },
        {
          headerName: this.$t('Pricing.Goods'), field: 'cargoChineseName', colId: 'cargoChineseName', width: 100
        },
        {
          headerName: this.$t('SeaExport.Consignee'), field: 'consigneeCode', colId: 'consigneeCode', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UploadAttachment'),
          field: 'customsFile',
          width: 120,
          noExport: true,
          cellRenderer: params => {
            const uploadFileClickHandler = this.documentManage.getPath('uploadFileClickHandler')
            if (!params.data) {
              return ''
            }
            const jobUuid = params.data.jobUuid
            const jobNo = params.data.jobNo
            const mbl = params.data.mbl
            return `<a onclick="${uploadFileClickHandler}('${jobUuid}','${jobNo}','${mbl}')" style="color:blue">${this.$t('Warehouse.WarehousePhotos')}</a>`
          }
        }
      ]
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('uploadFileClickHandler', function(jobUuid, jobNo, mbl) {
      context.uploadFileClickHandler(jobUuid, jobNo, mbl)
    })
    this.documentManage.set('routerPush', function(value) {
      context.routerPush(value)
    })
  },
  methods: {
    toQuery() {
      if (this.filter.isAdvancedQuery) {
        this.toAdvancedQuery()
      }
    },
    toSimpleQuery(keyword) {
      if (StrUtils.isEmpty(keyword)) {
        this.$message.warning(this.$t('SeaExport.Prompt1'))
        return
      }
      this.filter.jobNo = keyword
      this.query()
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filter.conditions = [... data]
      }
      this.query()
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.selectRow = null
      this.fullscreenLoading.close()
    },
    async query() {
      this.fullscreenLoading = getLoading()
      this.filter.pageNum = this.filterJson.pageNum
      this.filter.pageSize = this.filterJson.pageSize
      this.filter.branchId = this.$store.getters.currentOfficeId
      if (this.lob !== 'AI') {
        const colorType = Number(this.$store.state.settings.colorType) === 1
        if (colorType) {
          this.filter.requires = ['financeColor']
        }
      }
      let res
      if (this.lob === 'AI') {
        res = await queryAiWareHouse(this.filter).catch(() => {
          this.loadingEnd()
        })
      } else {
        res = await queryWareHouse(this.filter).catch(() => {
          this.loadingEnd()
        })
      }
      this.loadingEnd()
      this.filterJson.pageNum = res.data.pageNum
      this.filterJson.pageSize = res.data.pageSize
      this.total = Number(res.data.total)
      this.rowData = res.data.list
    },
    // 入库
    arriveStorageClickHandler() {
      if (this.checkWarehouse()) {
        return
      }
      this.inOrOutWarehouseDialog.visible = true
      this.inOrOutWarehouseDialog.type = 'in'
      this.inOrOutWarehouseDialog.title = this.$t('Warehouse.WarehouseIn')
    },
    // 出库
    deliverClickHandler() {
      if (this.checkWarehouse(true)) {
        return
      }
      this.inOrOutWarehouseDialog.visible = true
      this.inOrOutWarehouseDialog.type = 'out'
      this.inOrOutWarehouseDialog.title = this.$t('Warehouse.WarehouseOut')
    },
    checkWarehouse(isOut) {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return true
      }
      for (const item of selectedRows) {
        if (item.jobState !== 0) {
          this.$message.warning('[' + item.jobNo + '] ' + this.$t('Message.IsNotOperationStatus'))
          return true
        }
        if (isOut && !item.arriveStorageDate) {
          const name = CommonState.getName(SystemConstants.WAREHOUSE_IN_STATE_NOT_OUT)
          this.$message.warning('[' + item.jobNo + '] ' + name)
          return true
        }
      }
      return false
    },
    // 费用
    chargeClickHandler() {
      if (!this.selectRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return
      }
      if (this.selectRow.jobState > 1) {
        this.$message.warning('[' + this.selectRow.jobNo + '] ' + this.$t('Message.IsNotOperationStatus'))
        return
      }
      this.chargeDialog.visible = true
      this.chargeDialog.job = this.selectRow
    },
    // 新增仓库费
    warehouseClickHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoRecordSelected'))
        return
      }
      const jobList = []
      for (const item of selectedRows) {
        item['wareHouseAmount'] = 0
        if (!item.masterFlag) {
          jobList.push(item)
        }
      }
      for (const job of jobList) {
        if (job.jobState !== 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NewWarehouseFee'))
          return
        }
      }
      this.addWarehouseChargeDialog.visible = true
      this.addWarehouseChargeDialog.jobList = jobList
    },
    reloadSelectRow(data) {
      this.rowData.forEach(item => {
        if (item.truckingUuid === data.uuid) {
          item.driver = data.driver
          item.driverTel = data.driverTel
          item.printState = data.printState
        }
      })
      this.gridOptions.api.setRowData(this.rowData)
    },
    onPrint() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Warehouse.NoChoiceWarehouseToBePrinted'))
        return
      }
      const ids = []
      const idMap = {}
      for (const row of selectedRows) {
        if (!idMap.hasOwnProperty(row.jobUuid)) {
          ids.push(row.jobUuid)
        }
        idMap[row.jobUuid] = 1
      }
      const params = {
        USER_ID: this.$store.getters.userId,
        JOB_UUID: ids
      }
      this.templateSelectorDialog.visible = true
      this.templateSelectorDialog.data = params
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    async onGridCellFocused(event) {
      // 等待gridApi被赋值
      this.$nextTick(async() => {
        // 等待gridApi被赋值
        await ensureExecuteSuccess(() => this.gridApi)
        if (this.gridApi && event.column) {
          this.gridApi.forEachNode(node => {
            if (node.rowIndex === event.rowIndex) {
              this.selectedJob = node.data
              this.manageAuditStatus = this.selectedJob.manageAuditStatus
            }
          })
        }
      })
    },
    // 上传附件
    uploadFileClickHandler(jobUuid, jobNo, mbl) {
      const params = {
        uuid: jobUuid,
        mbl: mbl,
        jobNo: jobNo
      }
      this.uploadCommonFileDialog.model = params
      this.uploadCommonFileDialog.visible = true
    },
    // 出库或入库
    onSaveInOrOutState(date, remark, isIn) {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const updateJobs = []
      const jobMap = {}
      const updateJobsUuids = []
      selectedRows.forEach(item => {
        if (!item.masterFlag) {
          jobMap[item.jobUuid] = date
          const updateJob = Object.assign({ uuid: item.jobUuid }, date, remark)
          updateJobs.push(updateJob)
          if (!StrUtils.isEmpty(item.lclMasterUuid) && !updateJobsUuids.includes(item.lclMasterUuid)) {
            updateJobsUuids.push(item.lclMasterUuid)
            jobMap[item.lclMasterUuid] = date
            const updateMasterJob = Object.assign({ uuid: item.lclMasterUuid }, date, remark)
            updateJobs.push(updateMasterJob)
          }
        }
      })
      if (updateJobs.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataCanBeModified'))
        return
      }
      saveInOrOutWareHouse(updateJobs, this.lob, isIn).then(res => {
        if (res.data > 0) {
          const message = isIn ? this.$t('Warehouse.WarehouseInSuccess') : this.$t('Warehouse.WarehouseOutSuccess')
          this.$message.success(message)
          this.rowData.forEach(item => {
            if (jobMap.hasOwnProperty(item.jobUuid)) {
              Object.assign(item, jobMap[item.jobUuid])
            }
          })
          this.gridOptions.api.setRowData(this.rowData)
          this.inOrOutWarehouseDialog.visible = false
        }
      })
    },
    routerPush(jobNo) {
      if (this.lob === 'SI') {
        if (!checkPermission(['module_SIBOOKING'])) {
          this.$message.warning(this.$t('SeaExport.ImNotHavePermissionDetails'))
          return
        }
        this.$router.push({
          path: '/SeaImport/Booking',
          query: { jobNo }
        })
      } else {
        if (!checkPermission(['module_AIBooking'])) {
          this.$message.warning(this.$t('SeaExport.ImNotHavePermissionDetails'))
          return
        }
        this.$router.push({
          name: 'AiBooking',
          query: { jobNo }
        })
      }
    },
    onRowClickedEvent(e) {
      this.selectRow = e.data
    }
  }
}
</script>

<style lang="scss">
  .warehouse-home{
    textarea.el-textarea__inner {
      min-height: 100px !important;
    }
  }
</style>
